"use strict";
/**
 * QVET Cash Flow Review Enums
 *
 * Used in the cash flow review workflow where collaborators and admins
 * annotate QVET cash transactions (entradas/salidas de caja) with
 * supplier, account type, evidence, and invoice status.
 *
 * DB values use QVET abbreviations (CE, SE, FA, etc.) for historical
 * compatibility. Enum keys use descriptive English names.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_REASON_LABELS = exports.CashFlowInvalidReason = exports.FORMAL_ALLOWED_INVOICE_STATUSES = exports.CashFlowValidationStatus = exports.CashFlowInvoiceStatus = exports.CashFlowEvidence = exports.CashFlowAccountType = void 0;
/** Whether the transaction goes through formal or informal accounting */
var CashFlowAccountType;
(function (CashFlowAccountType) {
    CashFlowAccountType["FORMAL"] = "FORMAL";
    CashFlowAccountType["INFORMAL"] = "INFORMAL";
})(CashFlowAccountType || (exports.CashFlowAccountType = CashFlowAccountType = {}));
/** Evidence status for the transaction receipt/voucher */
var CashFlowEvidence;
(function (CashFlowEvidence) {
    /** Comprobante guardado (receipt saved in Dropbox) */
    CashFlowEvidence["SAVED"] = "CE";
    /** Se extravió (receipt existed but was lost/not captured) */
    CashFlowEvidence["MISSING"] = "SE";
    /** Sin comprobantes (no receipt for this type of payment) */
    CashFlowEvidence["NO_RECEIPT"] = "SC";
})(CashFlowEvidence || (exports.CashFlowEvidence = CashFlowEvidence = {}));
/** Invoice status for formal transactions */
var CashFlowInvoiceStatus;
(function (CashFlowInvoiceStatus) {
    /** Factura recibida */
    CashFlowInvoiceStatus["INVOICED"] = "FA";
    /** Proveedor factura automáticamente */
    CashFlowInvoiceStatus["AUTO_INVOICED"] = "FA_AUTO";
    /** Pendiente de factura */
    CashFlowInvoiceStatus["PENDING"] = "PE";
    /** No facturable (informales, etc.) */
    CashFlowInvoiceStatus["NOT_APPLICABLE"] = "SF";
})(CashFlowInvoiceStatus || (exports.CashFlowInvoiceStatus = CashFlowInvoiceStatus = {}));
/** Validation result for a cash flow entry */
var CashFlowValidationStatus;
(function (CashFlowValidationStatus) {
    CashFlowValidationStatus["VALID"] = "valid";
    CashFlowValidationStatus["INVALID"] = "invalid";
})(CashFlowValidationStatus || (exports.CashFlowValidationStatus = CashFlowValidationStatus = {}));
/**
 * Invoice statuses allowed when accountType is FORMAL.
 * NOT_APPLICABLE is only valid for INFORMAL accounts.
 */
exports.FORMAL_ALLOWED_INVOICE_STATUSES = [
    CashFlowInvoiceStatus.INVOICED,
    CashFlowInvoiceStatus.AUTO_INVOICED,
    CashFlowInvoiceStatus.PENDING,
];
/**
 * Structured reasons why a cash flow entry is invalid.
 * Replaces free-text auto-generated observations.
 * Only applies to SALIDA CAJA; ENTRADA CAJA is always valid.
 */
var CashFlowInvalidReason;
(function (CashFlowInvalidReason) {
    /** accountType missing (except DIFERENCIAS → always INFORMAL) */
    CashFlowInvalidReason["MISSING_ACCOUNT_TYPE"] = "SIN_TIPO_CUENTA";
    /** review.supplier missing/empty (SALIDA only) */
    CashFlowInvalidReason["MISSING_SUPPLIER"] = "SIN_PROVEEDOR";
    /** FORMAL account with invoiceStatus NOT_APPLICABLE */
    CashFlowInvalidReason["FORMAL_WITHOUT_INVOICE"] = "FORMAL_SIN_FACTURA";
    /** evidence field missing */
    CashFlowInvalidReason["MISSING_EVIDENCE"] = "SIN_EVIDENCIA";
})(CashFlowInvalidReason || (exports.CashFlowInvalidReason = CashFlowInvalidReason = {}));
/** Spanish labels for displaying invalid reasons in UI */
exports.INVALID_REASON_LABELS = {
    [CashFlowInvalidReason.MISSING_ACCOUNT_TYPE]: "Sin tipo de cuenta",
    [CashFlowInvalidReason.MISSING_SUPPLIER]: "Sin proveedor",
    [CashFlowInvalidReason.FORMAL_WITHOUT_INVOICE]: "Formal sin factura",
    [CashFlowInvalidReason.MISSING_EVIDENCE]: "Sin evidencia",
};
